import { ReactNode, useEffect } from 'react';
import { Grid, Typography } from '@mui/material';
import { Outlet } from 'react-router-dom';

import { Drawer } from 'components/main';
import { SplashScreen } from 'components/content';
import { useAppDispatch, useAppSelector, useProfile } from 'hooks';
import { toggleMenu } from 'store/app';
import { getStoredDrawerPinnedStateForUser } from 'utils';
import ActionBar from './ActionBar';

function Template(props: { children?: ReactNode }) {
  useProfile();

  const dispatch = useAppDispatch();

  const userState = useAppSelector((state) => state.user);
  const companyState = useAppSelector((state) => state.retailer.company);

  const { profile } = userState;
  const { data: companyData } = companyState;
  const userId = profile?.id;

  const { children } = props;

  useEffect(() => {
    if (userId) {
      const state = getStoredDrawerPinnedStateForUser(userId);
      dispatch(toggleMenu({ opened: state === 'expanded', pin: true, userId }));
    }
  }, [userId, dispatch]);

  if (!profile) {
    return <SplashScreen />;
  }

  return (
    <Grid
      container
      flexWrap="nowrap"
    >
      <Grid item>
        <Drawer />
      </Grid>

      <Grid
        flex={1}
        container
        sx={(theme) => ({
          width: '100%',
          height: '100vh',
          overflow: 'hidden',
          backgroundColor: theme.palette.common.white,
          overflowX: 'auto',
        })}
      >
        <Grid
          container
          flexWrap="nowrap"
          direction="column"
          sx={() => ({
            width: '100%',
            height: '100vh',
            minWidth: 1040,
          })}
        >
          <Grid
            px={2}
            container
            item
            flexShrink={0}
            alignItems="center"
            sx={(theme) => ({
              height: 65,
              backgroundColor: theme.palette.template.main,
            })}
          >
            <Typography
              sx={(theme) => ({
                color: theme.palette.template.contrastText,
              })}
            >
              {companyData?.companyName}
            </Typography>
            <Grid item px={1} ml="auto"><ActionBar /></Grid>
          </Grid>

          {children || <Outlet />}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Template;
